var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paystack',{attrs:{"amount":_vm.convertedAmount,"email":_vm.email,"paystackkey":_vm.paystackkey,"reference":_vm.reference,"callback":_vm.callback,"close":_vm.close,"embed":false}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }